"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.24531 10.1005H7.91251V16.9641C7.91251 17.0996 8.02232 17.2094 8.15783 17.2094H10.9846C11.1201 17.2094 11.2299 17.0996 11.2299 16.9641V10.1329H13.1465C13.2711 10.1329 13.376 10.0394 13.3902 9.91558L13.6813 7.38875C13.6893 7.31923 13.6673 7.24961 13.6208 7.19746C13.5742 7.14526 13.5076 7.11538 13.4377 7.11538H11.23V5.53144C11.23 5.05396 11.4871 4.81183 11.9942 4.81183C12.0665 4.81183 13.4377 4.81183 13.4377 4.81183C13.5732 4.81183 13.683 4.70198 13.683 4.56652V2.24713C13.683 2.11162 13.5732 2.00182 13.4377 2.00182H11.4484C11.4344 2.00113 11.4032 2 11.3573 2C11.0121 2 9.81242 2.06776 8.86472 2.9396C7.81468 3.90574 7.96064 5.06254 7.99553 5.26311V7.11533H6.24531C6.1098 7.11533 6 7.22513 6 7.36064V9.85519C6 9.9907 6.1098 10.1005 6.24531 10.1005Z",
    fill: fill
  }));
};

exports["default"] = _default;